import React, { createContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { HOST_API } from 'src/config';

const InternetConnectionContext = createContext({ isConnected: true });

const InternetConnectionProvider = ({ children }) => {
  const [internetStatus, setInternetStatus] = useState(false);

  useEffect(() => {
    let timeoutId = null;

    const checkInternetConnectivity = async () => {
      const controller = new AbortController();
      const timeoutAbort = setTimeout(() => controller.abort(), 5000);

      try {
        await fetch(`${HOST_API}api/connection`, {
          signal: controller.signal,
          headers: {
            Accept: 'application/json',
            accessToken: process.env.REACT_APP_ACCESS_TOKEN,
          },
        });
        setInternetStatus(true);
      } catch (error) {
        setInternetStatus(false);
      } finally {
        clearTimeout(timeoutAbort);
      }

      // Schedule next API call after 5 seconds (only after response is received)
      timeoutId = setTimeout(() => {
        checkInternetConnectivity();
      }, 5000);
    };

    // Start the polling
    checkInternetConnectivity();

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, []);

  return (
    <InternetConnectionContext.Provider
      value={{
        isConnected: internetStatus,
      }}
    >
      {children}
    </InternetConnectionContext.Provider>
  );
};

InternetConnectionProvider.propTypes = {
  children: PropTypes.node,
};

export { InternetConnectionProvider, InternetConnectionContext };
